import React from 'react';
import { Card, CardContent, Divider, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledColumnBox, StyledMediumTypography } from '../theme/StyledElements';

const StyledCard = styled(Card)(() => ({
    width: '420px',
    paddingBottom: '20px',
    boxShadow: '0px 3px 6px #00000029'
}));

const StyledSubscriptionContent = styled(StyledMediumTypography)(() => ({
    marginTop: '10px'
}));

export function SubscriptionCard(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <>
            <StyledCard variant="elevation">
                <CardContent>
                    <StyledMediumTypography color="#E37F1E" variant="h3" sx={{ marginTop: '20px' }}>
                        {t('welcomeOffer')}
                    </StyledMediumTypography>
                    <StyledMediumTypography variant="caption">
                        {t('10PercentRetrocessionSales')}
                    </StyledMediumTypography>
                    <Divider sx={{ borderColor: '#E37F1E', margin: '20px 0px' }} />
                    <StyledColumnBox>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent1')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent2')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent3')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent4')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent5')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent11')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent12')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent8')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent9')}
                        </StyledSubscriptionContent>
                        <StyledSubscriptionContent variant="caption" color="#E37F1E">
                            {t('subscriptionContent10')}
                        </StyledSubscriptionContent>
                    </StyledColumnBox>
                </CardContent>
            </StyledCard>
        </>
    );
}
